// ISO 3166 alpha-2 country code → flag emoji.
// Copy of packages/admin/src/tenants/flag.ts (deliberately duplicated
// to keep the consumer SPA standalone from admin internals).

export function flagFromIso(iso: string): string {
  const up = iso.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(up)) return '';
  const A = 'A'.charCodeAt(0);
  const offset = 0x1f1e6 - A;
  return (
    String.fromCodePoint(up.charCodeAt(0) + offset) +
    String.fromCodePoint(up.charCodeAt(1) + offset)
  );
}
